$(document).ready(function(){
   sliderrefresh();
});
$(".ajax-cart-featured-collection").on('DOMSubtreeModified', function(){
        sliderrefresh();
   
      });
const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartAlert: '.cart-alert',
  cartAbm: '.announcement-bar__message',
  cartAmount: '.cart-amount', 
  cartCount: '.cart-count', 
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartAlert = document.querySelector(defaults.cartAlert);
const cartAbm = document.querySelector(defaults.cartAbm);
const cartAmount = document.querySelector(defaults.cartAmount);
const cartCount = document.querySelector(defaults.cartCount);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const ajaxAddToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

window.bindAddToCartEvents = function(){
  document.querySelectorAll(defaults.addToCart).forEach((addToCartBtn)=>{
    addToCartBtn.classList.add("evt-binded");
    addToCartBtn.addEventListener("click", function(event){
      //console.log("clicked");
      event.preventDefault();
      const formID = event.currentTarget.closest(".product-form").querySelector("form").getAttribute("id");
      //console.log("formID",formID);
      //console.log($('#' + formID).serialize());
      addProductToCart(formID);
      openCartDrawer();
      openCartOverlay();
    })
  })
}

for (let i = 0; i < ajaxAddToCart.length; i++) {

  ajaxAddToCart[i].addEventListener('click', function(event) {


    event.preventDefault();
    //const formID = this.parentNode.getAttribute('id');
    const formID = $(this).parents('.product-form').find('form').attr('id'); 

    //console.log("formID",formID);
    //console.log($('#' + formID).serialize());

    addProductToCart(formID);


   if(window.innerWidth>768){
   openCartDrawer();
    
    openCartOverlay();
  }

    
 

  });

}

function addProductToCart(formID) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID).serialize(),
    error: addToCartFail,
    success: addToCartOk,
    
  });
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);
renderCart(cart);
      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = 'Cart is empty';
      }
     
      
      // $(".ajax-cart-featured-collection").load();
      $(".ajax-cart-featured-collection").load(" .ajax-cart-featured-collection");
      
      
        //checkoutButton.classList.add('is-hidden');
      // } else {
      //   renderCart(cart);
               
      //   // checkoutButton.classList.remove('is-hidden');
      // } 
    },
  });
  //  if ($('.slider-pr').hasClass('slick-initialized')) {
  //   destroysliderrefresh();
    
  // }  else{
  //    //sliderrefresh();
  // }
   
}

function changeItem(line, callback) {
  const quantity = 0;
 
  //console.log(line);
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
        renderCart(cart);
      }
    },
  });
}

function onCartUpdate(cart) {
  //console.log('items in the cart?', cart.item_count);
  
  $('.cartCount').text(cart.item_count);
  $('.cartCountSelector').text(cart.item_count);
}

function addToCartOk(product) {
     if(window.innerWidth>768){
 // console.log(product);
  cartModalContent.innerHTML = product.title + ' was added to the cart!';
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  //     openAddModal();
  openCartOverlay();
  fetchCart();
  }
  else{
    location.href='https://armacostlighting.myshopify.com/cart';
    return false;
  }

  

}

function removeProductFromCart() {
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  //     openAddModal();
  openCartOverlay();
}

function renderCart(cart) {

  if(cart.total_price < 9910 ){

    if(cart.item_count == 0){
      var tprice = Shopify.formatMoney(9900);
    }else{
      var tprice = Shopify.formatMoney(9910-cart.total_price);
    }
   
     cartAlert.innerHTML = `<h5>${window.theme.freeShippingProgressMessage.replace('|| amount ||', tprice)}</h5>`;
     }else{
      cartAlert.innerHTML = `<h5> ${window.theme.freeShippingMessage}</h5>`;
     }
  
  
     cartCount.innerHTML = cart.item_count;
     cartAmount.innerHTML = Shopify.formatMoney(cart.total_price);
    
    // if(cart.total_price < 9900 ){
    //  cartAbm.innerHTML = '<h5> If you spend ' +  Shopify.formatMoney(9900-cart.total_price) + ' more, you qualify for free shipping!</h5>';
    //  }else{
    //   cartAbm.innerHTML = '<h5> Congrats! You get free shipping.</h5>';
    //  }
  
  var cart_total_header = Shopify.formatMoney(cart.total_price)
  $('.data-subtotal').text(Shopify.formatMoney(cart.total_price));
  $('.data-subtotal_header').text('YOUR CART: '+ cart_total_header);
  $('.cartTotalSelector').text(Shopify.formatMoney(cart.total_price));
  if(cart.item_count > 0 ){
    $('.main_subtotal').show();
    $('.ajax-cart-drawer__content').removeClass('Cart__Empty');
    $('.free_shipping_box .wrapper-cartCount ').show();
  
  }
  else{
    $('.main_subtotal').hide();
    $('.ajax-cart-drawer__content').addClass('Cart__Empty');
    $('.free_shipping_box .wrapper-cartCount ').hide();
  }

  // $(".ajax-cart-featured-collection").load(" .ajax-cart-featured-collection");
  // if(!$('.slider-pr').hasClass('slick-initialized')) {
  //     sliderrefresh();
   
  // }
  clearCartDrawer();
  var v12 = 0;
  var v24 = 0;
 
  cart.items.forEach(function(item, index) {
    jQuery.getJSON(window.Shopify.routes.root + 'products/'+item.handle+'.js', function(product){
     
      var tags = product.tags.join(",");

      if(tags.indexOf("CC_voltage_tag:24V") >= 0){
        v24 = 1;
      }
      if(tags.indexOf("CC_voltage_tag:12V") >= 0){
        v12 = 1;
      }

      
      //if((index+1) == cart.items.length){
       //console.log(v12); 
       //console.log(v24); 
        if(v12 == 1 && v24 == 1){
          $(".cart_alert_message").show();
        }else{
          $(".cart_alert_message").hide();
        }

     // }
    });
    //cart.total_price < 3000 ? 'Want free shipping? It\'s only ' + Shopify.formatMoney(3000 - cart.total_price, settings.moneyFormat) + ' away!' : 'Yahoo! No pay-for-shipping for you!'
    

    console.log(item);
    const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
    const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
    const productPrice = '<div class="ajax-cart-item__price">' +   Shopify.formatMoney(item.line_price) +'</div>';
    // const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
    const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '">Remove</div>';
    const MiniCartQty = '<div class="mini_qtybox" data_handle="'+item.handle+'"><input type="text" id="quantity" name="quantity" min="1" max="'+item.quantity+'" value="'+item.quantity+'" class="quantity-selector quantity-input"><input type="hidden" value="'+item.variant_id+'" class="mini_cart_variant_id"><input type="hidden" value="'+item.quantity+'" class="mini_cart_product_qty"></div>';
    //const concatProductInfo = '<div class="CartItemWrapper"><div class="CartItem " data-line="' + Number(index + 1) + '"><div class="CartItem__ImageWrapper AspectRatio"><div class="AspectRatio" style="--aspect-ratio: 1.0"><img class="CartItem__Image" src="' + item.image + '" ></div></div><div class="CartItem__Info"><div class="CartItem_Info_top"><h2 class="CartItem__Title Heading">' + item.title + '</h2></div><div class="CartItem__QuantitySelector"><div class="QuantitySelector"><div class="mini_qtybox"><input type="text" id="quantity" name="quantity" min="1" max="'+item.quantity+'" value="'+item.quantity+'" class="quantity-selector quantity-input QuantitySelector__CurrentQuantity"><input type="hidden" value="'+item.variant_id+'" class="mini_cart_variant_id"><input type="hidden" value="'+item.quantity+'" class="mini_cart_product_qty"><button style="display:none;" old_data_qty="'+item.quantity+'" data_handle="'+item.handle+'" class="add_all_qty">Add</button></div></div></div><div class="CartItem__Actions Heading Text--subdued" style="text-align: center"><div class="CartItem__Meta Heading Text--subdued"><div class="CartItem__PriceList"><span class="CartItem__Price Price" data-money-convertible="">'+  Shopify.formatMoney(item.line_price) +' </span></div></div><div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"><img src="https://cdn.shopify.com/s/files/1/0562/6285/2644/files/Path_1655.png?v=1652852803"></div></div></div></div></div>';
    const concatProductInfo = '<div class="CartItemWrapper"><div class="CartItem " data-line="' + Number(index + 1) + '"><div class="CartItem__ImageWrapper AspectRatio"><div class="AspectRatio" style="--aspect-ratio: 1.0"><img class="CartItem__Image" src="' + item.image + '" ></div></div><div class="CartItem__Info"><div class="CartItem_Info_top"><h2 class="CartItem__Title Heading">' + item.title + '</h2><span class="CartItem__Sku">SKU: ' + item.sku +'</span></div><div class="CartItem__QuantitySelector"><div class="QuantitySelector"><div class="mini_qtybox"><span class="mini_btnqty qtyminus icon icon-minus"></span><input type="text" id="quantity" name="quantity" min="1" max="'+item.quantity+'" value="'+item.quantity+'" class="quantity-selector quantity-input QuantitySelector__CurrentQuantity"><input type="hidden" value="'+item.variant_id+'" class="mini_cart_variant_id"><input type="hidden" value="'+item.quantity+'" class="mini_cart_product_qty"><span class="mini_btnqty qtyplus icon icon-plus"></span></div></div></div><div class="CartItem__Actions Heading Text--subdued" style="text-align: center"><div class="CartItem__Meta Heading Text--subdued"><div class="CartItem__PriceList"><span class="CartItem__Price Price" data-money-convertible="">'+  Shopify.formatMoney(item.line_price) +' </span></div></div><div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"><img src="https://cdn.shopify.com/s/files/1/0562/6285/2644/files/Path_1655.png?v=1652852803"></div></div></div></div></div>';

      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

  });
  
const concatProductInfo_btn = '<h5 class="cart_alert_message" style="display:none;"><strong>Note: Your cart contains products with different voltages (12V/24V) To work properly, products installed together must be the same voltage.        Questions? Contact <a href="mailto:support@armacostlighting.com">support@armacostlighting.com</a></strong><button onClick="cart_message_hide()" id="pop_up_close" class="close_btn" data-action="" data-drawer-id=""><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg>  </button></h5>';
 cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo_btn;

  removeFromCart = document.querySelectorAll(defaults.removeFromCart);

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function() {
   const line = $(this).closest('.CartItem').attr("data-line");
     // const line = $(this).parents().find('.CartItem').attr("data-line");
    // console.log(line);
        if (confirm(' Are you sure you want to delete this item?')) {
            changeItem(line);
        } else {
            return false;
        }
      
      
    });

  }
}

function sliderrefresh() {
var slider = $('.upsell_slider');

if(!slider.hasClass('slick-initialized')) {
  slider.slick({
    dots: false,
    speed: 300,
    autoplay:true,
    loop:false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}


var li_length = $(".slider-pr").find("li").length;

  if(li_length > 0){
    $(".ajax-cart_featured_title").css("display", "block");
    $(".ajax-cart_featured_title2").css("display", "block")
  }else{
    $(".ajax-cart_featured_title").css("display", "block");
        $(".ajax-cart_featured_title2").css("display", "block")
  }
}

function openCartDrawer() {
  if(window.innerWidth>768){
  cartDrawer.classList.add('is-open');
  }
  else{
    location.href='/cart';
    return false;
  }
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
  //     closeAddModal();
  closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  //     closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

 // $('.js-ajax-cart-drawer-trigger1').click(function() {
 //  event.preventDefault();
 //  fetchCart();
 //  openCartDrawer();
 //  openCartOverlay();
 //   });

cartDrawerTrigger.addEventListener('click', function(event) {
  cartredict();
  event.preventDefault();
  fetchCart();
  //openCartDrawer();
  openCartOverlay();

});

function cartredict() {
  location.href = "https://armacostlighting.myshopify.com/cart";
}

// if you want to use drawer then comment the above function cartredict() and remove the comment of openCartDrawer();

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
});


$(document).on("click",".mini_qtybox .mini_btnqty",function() {
  var qty = parseInt($(this).parent('.mini_qtybox').find('.quantity-input').val());
  var pro_variation_id = parseInt($(this).parent('.mini_qtybox').find('.mini_cart_variant_id').val());
  var line = $(this).closest('.CartItem').attr('data-line');
  
  if($(this).hasClass('qtyplus')) {
    qty++;

    changeQunatity(pro_variation_id);
  }else {

    if(qty > 1) {
      qty--;
    }
    //pro_qty = parseInt(pro_qty)-1;
    if(qty > 0){
      removeSigleQtyItem(line, qty)
    }else{
      changeItem(line);
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.mini_qtybox').find('.quantity-input').val(qty);
});


$(document).on("keyup","input[name='quantity']",function() {
  var qty = parseInt($(this).parent('.mini_qtybox').find('.quantity-input').val());
  var pro_variation_id = parseInt($(this).parent('.mini_qtybox').find('.mini_cart_variant_id').val());
  var line = $(this).closest('.CartItem').attr('data-line');

  if(qty > 0){
    removeSigleQtyItem(line, qty)
  }else{
    changeItem(line);
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.mini_qtybox').find('.quantity-input').val(qty);
 });

function changeQunatity(pro_variation_id){
  let formData = {
    'items': [{
      'id': pro_variation_id,
      'quantity': 1
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    console.log(response);
    fetchCart();
  })
  .catch((error) => {
  });
}

function removeSigleQtyItem(line, quantity) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      console.log(cart);
      fetchCart();
    },
  });
}

$(function(){

  $('.ajax-cart-qu-add').click(function () {		
    var selectedInput = $(this).prev('input');		
    if (selectedInput.val() < 10) {		
      selectedInput[0].stepUp(1);
    }	
  });

  $('.ajax-cart-qu-sub').click(function () {		
    var selectedInput = $(this).next('input');		
    if (selectedInput.val() > 0) {
      selectedInput[0].stepDown(1);
    }	
  });


  $(".cart-count-mobile").on('click', function (e) {
    e.preventDefault();
    $(document).find(".js-ajax-cart-drawer").addClass('is-open');

  });
  $(".cart_mobile").on('click', function (e) {
    e.preventDefault();
    $(document).find(".js-ajax-cart-drawer").addClass('is-open');

  });


});

function cart_message_hide()
  {
         $(".cart_alert_message").hide();
  }